/* JOFFAR v3.1.0 — Facticied */
/**

 * 01) collection

 */

var scrollToCollectionTop = function() {

  $('html, body').animate({

    scrollTop: 0

  }, 100);

};



var collectionFilterPostInit = function() {



  //-- need first for now
  // doCollectionWishListPersistent();



  //-- is for Collection filter Section

  var sectionId = "collection-template";



  //-- is there in joffar-theme.js.liquid

  joffar_initQuickShop(sectionId);

  joffar_activateQuickShop();



  scrollToCollectionTop();

  ajaxCart.init({
    formSelector: '[data-product-form]',
    cartContainer: '#CartContainer',
    addToCartSelector: '.joffar_AddToCart',
    cartCountSelector: '.CartCount',
    cartCostSelector: '.CartCost',
    moneyFormat: DT_THEME.moneyFormat
  });
 loadSPRXHR();
        
$('.input_price_range').on('input', function () {
  if($(this).hasClass('price_range_start')) {
    $(".joffar_price_input_start").attr('value', $(this).val());
  }
   if($(this).hasClass('price_range_end')) {
    $(".joffar_price_input_end").attr('value', $(this).val());
  }
});
    
  
};


var collectionFilterPostInitTemp = function() {
  var sectionId = "collection-template";



  //-- is there in joffar-theme.js.liquid

  joffar_initQuickShop(sectionId);

  joffar_activateQuickShop();

  loadSPRXHR();
};




var loadSPRXHR = function loadSPRXHR() {

  if (document.querySelector(".spr-badge")) {

    SPR.registerCallbacks();

    SPR.initRatingHandler();

    SPR.initDomEls();

    SPR.loadProducts();

    SPR.loadBadges();

  }

};



var showHideClearFilter = function() {

  var constraint = joffarCollectionFilter.getConstraint();

  if (constraint.length > 0) {

    $(".joffar_ClearAll").css("display", "block");

  } else {

    $(".joffar_ClearAll").css("display", "none");

  }

};



var resetGrid = function() {

};



/*** 02) wish list Persistent All ***/



var doProductGridWishListPersistent = function(class_element) {

  var joffarCompareListOther = joffarCompareList; //Object.assign( {}, joffarWhistList );

  window.joffarCompareListOther = joffarCompareListOther;

  joffarCompareListOther.setListLocalStorageKey('joffar-product-compare-list', ",");


  new Vue({

    el: class_element,

    delimiters: ['${', '}'],

    data: {},

    computed: {},

    methods: {

      isInWishList: function(handle) {

        //console.log("wishilist---"+ handle + '---' + joffarWhistList.isAddedIntoList(handle));
        return joffarWhistList.isAddedIntoList(handle);
      },



      isInCompareList: function(handle) {
        //console.log("compareList---"+ handle + '---' + joffarCompareListOther.isAddedIntoList(handle));
        return joffarCompareListOther.isAddedIntoList(handle);
      },

      compareItemCount: function() {

        var items = joffarCompareListOther.getWishlist();



        return items.length;

      }

    }

  });

};



var doCollectionWishListPersistent = function() {

  doProductGridWishListPersistent('.joffar_VProdWrapper');

};



var doCollectionWishListPersistentOther = function() {

  doProductGridWishListPersistent('.joffar_VProdWrapperOther');

};



var doProductSingleWishListPersistent = function() {

  doProductGridWishListPersistent('.joffar_VProdWishList');

};





var setWishListCount = function() {

  if (document.querySelector('.joffar-wishlist-cnt')) {

    var items = joffarWhistList.getWishlist();
    var cnt = items.length;

    var elementList = document.querySelectorAll(".joffar-wishlist-cnt");
    elementList.forEach((element) => {
      if (cnt > 0 ) {
        element.innerHTML = cnt;
        element.style.display = 'block';

      } else {

        element.innerHTML = 0;
        //               element.style.display = 'none';

      }
    });      
  }

};



/**

 * 03) Add to Cart

 * 

 */

const joffar_AddToCart = function(frm) {

  joffarGeneral.loadingAxiosAddToCartCreation();



  axios.post('/cart/add.js', frm)

  .then((response) => {

    window.joffarGeneral.closeMiniCart();

    window.joffarGeneral.showMiniCart();

  })

  .catch((error) => {});

};



const joffar_QuickAddToCart = function(frm) {

  joffarGeneral.loadingAxiosAddToCartCreation();



  axios.post('/cart/add.js', frm)

  .then((response) => {

    $.magnificPopup.close();

    window.joffarGeneral.showMiniCart();

  })

  .catch((error) => {});

};



const joffar_AddToCartOther = function(frm) {

  joffarGeneral.loadingAxiosAddToCartCreation();

  axios.post('/cart/add.js', frm)

  .then((response) => {

    Shopify.moveAlong();

  })

  .catch((error) => {});

};





/**

 * 04) wishList and compare pre/post loading

 * 

 */

const setWhishListLoaingClass = function(el) {

  el.removeClass('joffar-icon-add-wlist-loaded');

  el.addClass('joffar-icon-add-wlist-loading');

};



const setWhishListLoadedClass = function(el) {

  setTimeout(function() {

    el.removeClass('joffar-icon-add-wlist-loading');

    el.addClass('joffar-icon-add-wlist-loaded');

  }, 3000);



  //-- set wish list after loaded page

  el.attr("href", "/pages/wishlist");

  el.removeClass("joffar_WhishListAddBtn");



  var viewMyWishList = (DT_THEME.strings.viewMyWishList == '') ? DT_THEME.strings.viewMyWishList : 'View My WishList';

  el.find('span').html(viewMyWishList);

};



const specialReloadWhishListGrid = function() {



};





const setCompareListLoaingClass = function(el) {

  el.removeClass('joffar-icon-add-compare-loaded');

  el.addClass('joffar-icon-add-compare-loading');

};



const setCompareListLoadedClass = function(el) {

  setTimeout(function() {

    el.removeClass('joffar-icon-add-compare-loading');

    el.addClass('joffar-icon-add-compare-loaded');

  }, 3000);



  //-- set wish list after loaded page

  el.attr("href", "/pages/compare");

  el.removeClass("joffar_compareListAddBtn");

};





/**

 * wishlist and compare list grid

 */

var joffar_WishListGrid; 

var whishListReload = function() {

  joffar_WishListGrid.getList();

  joffar_WishListGrid.isEmpty();

};



function getWishList() {

  joffar_WishListGrid = new Vue({

    el: "#joffar_WishListGrid",

    delimiters: ['${', '}'],

    data: {

      wishListRecords: [],

      isNoRecords: false,

      wishListRecordsTemplate: [{

        id: '',

        product_title: '',

        product_handle: '',

        product_image: '',

        vendor: '',

        type: '',

        money_price: '',

        price_min: '',

        price_max: '',

        available: '',

        price_varies: '',

        variant_id: '',

        variant_title: '',

        sku: '',

        quantity: "1",

        product_url: ''

      }]



    },

    computed: {

      // a computed getter

      wishList: function() {

        var Records = joffarWhistList.getWishListRecords();



        this.wishListRecords = Records;

        return this.wishListRecords;

      },



      isEmpty: function() {



        return false;

      }

    },

    mounted: function() {

      this.getList();

      this.isEmpty();

    },

    methods: {

      getList: function() {

        var Records = joffarWhistList.getWishListRecords();



        this.wishListRecords = Records;

        return this.wishListRecords;

      },

      isEmpty: function() {

        if (this.wishListRecords.length > 0) {

          if (typeof this.wishListRecords === 'object') {

            if (this.wishListRecords[0].id == '') {

              this.isNoRecords = true;

            } else {

              this.isNoRecords = false;

            }

          }

          return this.isNoRecords;

        } else {

          this.isNoRecords = true;

          return this.isNoRecords;

        }

      },

      remove: function(productHandle) {

        console.log('remove from wish list ' + productHandle);

        try {



          var p2  = Promise.resolve(1);

          // var p2 = new Promise(function(resolve, reject) {

          //     resolve(1);

          // });



          p2.then(function(value) {

            joffarGeneral.openWhishListRemovePreload();

            joffarWhistList.removeWhishlist(productHandle);



            return value + 1;

          }).then(function(value) {

            setTimeout(function(){ 

              var items = joffarWhistList.getWishlist();

              var cnt = items.length;

              console.log("wish list count " + cnt);



              if (cnt <= 0 ) {

                window.location.reload();

              }



              whishListReload();

              joffarGeneral.closeWhishListRemovegPreload();



              $('#row_' + productHandle).remove();

              setWishListCount();

              return value + 1;

            }, 5000);

          }).then(function(value) {



            return value + 1;

          }).then(function(value) {

            return value + 1;

          });



        } catch (err) {} finally {



        }

      }

    }

  });







}



function getCompareList() {



  var joffar_CompareListGrid = new Vue({

    el: "#joffar_CompareListGrid",

    delimiters: ['${', '}'],

    data: {

      compareListRecords: [],

      isNoRecords: false,

      wishListRecordsTemplate: [{

        id: '',

        product_title: '',

        product_handle: '',

        product_image: '',

        vendor: '',

        type: '',

        money_price: '',

        price_min: '',

        price_max: '',

        available: '',

        price_varies: '',

        variant_id: '',

        variant_title: '',

        sku: '',

        quantity: "1",

        product_url: ''

      }]

    },

    computed: {

      createContact: function() {},

      resetForm: function() {}

    },

    mounted: function() {

      this.getList();

      this.isEmpty();

    },

    methods: {

      getList: function() {

        var Records = joffarCompareList.getCompareListRecords();

        this.compareListRecords = Records;

        return this.compareListRecords;

      },

      isEmpty: function() {

        if (this.compareListRecords.length > 0) {

          if (typeof this.compareListRecords === 'object') {

            if (this.compareListRecords[0].id == '') {

              this.isNoRecords = true;

            } else {

              this.isNoRecords = false;

            }

          }

          return this.isNoRecords;

        } else {

          this.isNoRecords = true;

          return this.isNoRecords;

        }

      },

      remove: function(productHandle) {





        try {

          var p2 = new Promise(function(resolve, reject) {

            resolve(1);

          });



          p2.then(function(value) {

            joffarGeneral.openCompareListRemovePreload();



            return value + 1;

          }).then(function(value) {

            joffarCompareList.removeWhishlist(productHandle);

            joffarCompareList.setupGrid('', 'compareList');



            return value + 1;

          }).then(function(value) {

            joffarGeneral.closeCompareListRemovegPreload();



            return value + 1;

          }).then(function(value) {

            $('.record-' + productHandle).remove();

            compareListReload();



            return value + 1;

          });





        } catch (err) {} finally {

          // $('.record-'+productHandle).remove();

          // joffarCompareList.setupGrid('', 'compareList');



        }





      }

    }

  });







  var compareListReload = function() {

    joffar_CompareListGrid.getList();

    joffar_CompareListGrid.isEmpty();

  };



}





const joffarUpStream = function() {



};



/**

 * 05) recommendated product

 */

const recomendatedProductPostInit = function() {



  //doProductGridWishListPersistent('.joffar_VProdRecommendations');



  //-- is for Collection filter Section

  var sectionId = "collection-template";



  //-- is there in joffar-theme.js.liquid

  joffar_initQuickShop(sectionId);

  joffar_activateQuickShop();

  scrollToCollectionTop();
  ajaxCart.init({
    formSelector: '[data-product-form]',
    cartContainer: '#CartContainer',
    addToCartSelector: '.joffar_AddToCart',
    cartCountSelector: '.CartCount',
    cartCostSelector: '.CartCost',
    moneyFormat: DT_THEME.moneyFormat
  });

};



const loadProductRecommendationsIntoSection = function() {

  var productRecommendationsSection = document.querySelector(".product-recommendations");

  if (productRecommendationsSection === null) {

    return;

  }

  var productId = productRecommendationsSection.dataset.productId;

  var limit = productRecommendationsSection.dataset.limit;

  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit=" + limit + "&product_id=" + productId;


  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {

    if (request.status >= 200 && request.status < 300) {

      var container = document.createElement("div");

      container.innerHTML = request.response;

      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;


      recomendatedProductPostInit();


    }

  };

  request.send();

};

document.addEventListener("shopify:section:load", function(event) {

  if (event.detail.sectionId === "product-recommendations") {

    loadProductRecommendationsIntoSection();

  }

});



!(function($) {

  "use strict";



  /**

     * 01) wish list

     */

  $(document).on("click", ".joffar_WhishListAddBtn", function(event) {

    event.preventDefault();

    var self = jQuery(this);

    var productHandle = self.attr("data-product_handle");



    var addToWishList  = Promise.resolve('addToWishList');



    addToWishList.then(function(value){

      joffarGeneral.openWhishListAddingPreload();

      setWhishListLoaingClass(self);

      return 'addToWishList';

    }).then(function(value) { 

      joffarWhistList.updateWishlist(productHandle);

      return 'addToWishList';

    }).then(function(value) {     

      joffarGeneral.closeWhishListAddingPreload();

      setWhishListLoadedClass(self);

      setWishListCount();

    }).catch(function(){

    });        

  });



  if (document.querySelector(".joffar_WishListGrid")) {

    //-- set wish list records

    var gridWishList  = Promise.resolve('gridWishList');

    gridWishList.then(function(value){

      joffarGeneral.openCompareListRemovePreload();

      joffarWhistList.setupGrid('', "wishList");

      return 'gridWishList';

    }).then(function(value) { 

      setTimeout(function(){ 

        getWishList();

        whishListReload();

        joffarGeneral.closeCompareListRemovegPreload();

        return 'gridWishList';



      }, 3000);



    }).then(function(value) {   

    }).catch(function(err){

      console.log('joffar_WishListGrid error' + err);

    });        



    //joffarWhistList.setupGrid(getWishList, "wishList");

  }



  $(document).on("click", ".joffar_RemoveWhishList", function(event) {

    event.preventDefault();

    var self = jQuery(this);

    var productHandle = self.attr("data-product_handle");



    //$('#row_'+productHandle).remove();

    $(this).closest("tr").remove();



    Promise.all([

      joffarGeneral.openWhishListRemovePreload(),

      joffarWhistList.removeWhishlist(productHandle),

      joffarGeneral.closeWhishListRemovegPreload(),

      specialReloadWhishListGrid()

    ]).then(values => {});

  });





  if (document.querySelector(".joffar_VProdWishList")) {

    doProductSingleWishListPersistent();

  }



  var a_vueProductGrid = ['.joffar_VProdWrapper', '.joffar_VProdWrapperOther', '.joffar_VProdWrapperHot', '.joffar_VRelatedProducts', '.joffar_VProdRecommendations'];

  a_vueProductGrid.forEach(function(element, index) {

    if (document.querySelector(element)) {

      doProductGridWishListPersistent(element);

    }

  });



  if (document.querySelector(".joffar_vProdWrap")) {

    $(".joffar_vProdWrap").each(function(i, el) {



      var className = el.className;

      var a_className = className.split(' ').map(string => string.trim());



      var a_class = [];

      a_className.forEach(function(item, index){

        if(item.trim() != '') {

          a_class.push(item.trim());  

        }  

      });



      var className = "." + a_class.join('.');

      var className = className.trim();

      doProductGridWishListPersistent(className);

    });

  }



  /**

     * 02 RecommendationsIntoSection

     */

  loadProductRecommendationsIntoSection();



  /**

	 * 03 compare

	 */

  joffarCompareList.setListLocalStorageKey('joffar-product-compare-list', ",");



  $(document).on("click", ".joffar_compareListAddBtn", function(event) {

    event.preventDefault();

    var self = jQuery(this);

    var productHandle = self.attr("data-product_handle");



    var items = joffarCompareList.getWishlist();



    if (items.length == 4) {

      alert(DT_THEME.strings.minCompareProduct);

    } else {

      Promise.all([

        joffarGeneral.openCompareListAddingPreload(),

        setCompareListLoaingClass(self),

        joffarCompareList.updateWishlist(productHandle),

        joffarGeneral.closeCompareListRemovegPreload(),

        setCompareListLoadedClass(self)

      ]).then(values => {



      });

    }

  });



  $(document).on("click", ".joffar_compareListLink", function(event) {

    event.preventDefault();

    var self = jQuery(this);

    var productHandle = self.attr("data-product_handle");

    var compareUrl = self.attr("href");



    var items = joffarCompareList.getWishlist();



    if (items.length <= 1) {

      alert(DT_THEME.strings.minCompareProductNav);

    } else {

      window.location.href = compareUrl;

    }

  });





  if (document.querySelector(".joffar_CompareListGrid")) {

    //-- set wish list records

    joffarCompareList.setupGrid(getCompareList, 'compareList');

  }





  $(document).on("click", ".joffar_RemoveCompareList", function(event) {

    event.preventDefault();

    var self = jQuery(this);

    var productHandle = self.attr("data-product_handle");



    $('.record-' + productHandle).remove();



    Promise.all([

      joffarGeneral.openCompareListRemovePreload(),

      joffarCompareList.removeWhishlist(productHandle),

      joffarGeneral.closeCompareListRemovegPreload(),

      getCompareList()

    ]).then(values => {});

  });



  /**

     * 04 side bar

     */

  $(document).on("click", ".joffar_CollectionFilter", function(event) {

    event.preventDefault();

    var self = jQuery(this);

    var constraintValue = self.attr("data-value");



    if (self.hasClass("active")) {

      self.removeClass('active');

    } else {

      self.addClass('active');

    }



    //-- update search filter Constraint

    joffarCollectionFilter.updateConstraint(constraintValue);



    //-- load collection grid

    joffarCollectionFilter.updateCollectionGrid();



    showHideClearFilter();



  });



  //-- side bar clear filter

  $(document).on("click", ".joffar_ClearAll", function(event) {

    event.preventDefault();

    var self = jQuery(this);



    // reset filter

    joffarCollectionFilter.resetConstraint();



    // clear Filter selection

    $(".joffar_CollectionFilter").removeClass('active');



    //-- load collection grid

    joffarCollectionFilter.updateCollectionGrid();



    showHideClearFilter();



  });





  //-- collection pagination

  $(document).on("click", ".joffar_Pagination", function(event) {

    event.preventDefault();

    var self = jQuery(this);



    var paginationURL = self.attr("href");



    var a_params = {};



    //-- load collection grid

    joffarCollectionFilter.updateCollectionGrid(a_params, paginationURL);





    showHideClearFilter();

  });





  //-- collection pagination

  $(document).on("change", ".joffar_SortBy", function(event) {

    event.preventDefault();

    var self = jQuery(this);



    var urlFilter = new URL(window.location.href);

    var search_params = urlFilter.searchParams;

    search_params.set('sort_by', this.value);



    urlFilter.search = search_params.toString();



    var collectionFilterURL = urlFilter.toString();



    var a_params = {};

    // a_params['sort_by'] = this.value;



    //-- load collection grid

    joffarCollectionFilter.updateCollectionGrid(a_params, collectionFilterURL);



    showHideClearFilter();

  });











  //-- default initCall

  showHideClearFilter();

  //-- deal Timer

  //joffarProductDealTimerStart();



  //-- 05 cart

  $(document).on("click", ".joffar_AddToCartBtn", function(event) {

    event.preventDefault();

    var frmData = $(".shopify-product-form").serialize();

    joffar_AddToCart(frmData);

  });



  $(document).on("click", ".joffar_QuickAddToCartBtn", function(event) {

    event.preventDefault();



    var productVarientId = $(this).attr("data-product-varient-id");

    $(".joffar_quickProductVarientId").val(productVarientId);



    var frmData = $(".shopify-product-quick-form").serialize();

    joffar_QuickAddToCart(frmData);

  });





  $(document).on("submit", "#bundleAddToCartFrmId", function(event) {

    event.preventDefault();



    const setShopifyQue = function() {

      Shopify.queue = [];

      Shopify.isBundleDiscount = true;



      bundleProductIds.forEach(element => {

        var productId = element;

        var productVarientId = $("#bundle_product_price_" + productId).attr("data-varient-id");





        if (productVarientId != '' && $('#bundle_chk_' + productId).is(":checked")) {

          Shopify.queue.push({

            variantId: productVarientId,

          });

        } else {

          Shopify.isBundleDiscount = false;

        }

      });



    };



    const applyBundleDiscount = function(discount_code) {



      if (Shopify.isBundleDiscount == true) {

        axios.get('/discount/' + discount_code, {})

        .then(function(response) {



        });

      }

    };



    const doBundleAddToCart = function() {

      setShopifyQue();

      Shopify.moveAlong = function() {

        if (Shopify.queue.length) {

          var request = Shopify.queue.shift();



          var frmData = 'id=' + request.variantId + '&quantity=1';

          joffar_AddToCartOther(frmData);



        } else {

          finalBundleCallBack();

        }

      };



      Shopify.moveAlong();

    };





    const finalBundleCallBack = function() {



      //-- apply discount

      var mainProductId = BUNDLE_MAIN_PRODUCT_ID;

      applyBundleDiscount('DT-DISCOUNT-' + mainProductId);



      //-- trigger mini cart link

      window.joffarGeneral.showMiniCart();

    };



    Promise.resolve(doBundleAddToCart())

    .then(function() {



    });





  });



  /***

	 * 07 predictive search 

	 */



  var hideDT_SearchResultSection = function() {

    $(".joffar_PredictiveSearchResult_Section").css('display', 'none');

  };



  var showDT_SearchResultSection = function() {

    $(".joffar_PredictiveSearchResult_Section").css('display', 'block');

  };



  $(document).on("click", ".joffar_SearchClose", function(event) {

    event.preventDefault();

    var self = jQuery(this);

    $("#SearchInput").val('');

    $("#SearchInput").focus();

    hideDT_SearchResultSection();



    self.css('display', 'none');

  });



  $(document).click(function() {

    hideDT_SearchResultSection();

  });



  $(".joffar_TopStickySearchBtn").click(function(ev) {

    ev.preventDefault();

    $("#joffar_top-sticky").slideDown('slow');

    scrollToCollectionTop();

  });



  $(".joffar_TopStickySearchCloseBtn").click(function(ev) {

    ev.preventDefault();

    $("#joffar_top-sticky").slideUp('slow');

  });





  setWishListCount();



})(jQuery);